import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { deleteAssembly, getConfigurationTableData } from "../../axios";
import { useDispatch, useSelector } from "react-redux";
import loader from "../../loader.gif";
import "./index.css";

function DeleteAssemblyModal({
  isModalOpen,
  setIsModalOpen,
  selectedDeleteItem,
  refetchApi,
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState("");
  const [configFileExists, setConfigFileExists] = useState(false);
  const configTableData = useSelector((state) => state?.ConfigTableData);
  console.log("configTableData: ", configTableData)
  

  const handleOnDelete = () => {
    let payload = {
      assemblyID: selectedDeleteItem?.assemblyID,
    };
    setLoading(true);
    dispatch(deleteAssembly(payload))
      .then((result) => {
        refetchApi();
        setLoading(false);
        setResponse(result);
      })
      .catch((err) => {
        setLoading(false);
        setResponse(err?.response?.data);
      });
  };

  useEffect(() => {
    return () => {
      setLoading(false);
      setResponse("");
    };
  }, []);

  useEffect(()=>{
    if(configTableData.data.length > 0){
      const allConfigAssemblyIDs = configTableData?.data?.map(config => config.assemblyID) 
      if(allConfigAssemblyIDs.includes(selectedDeleteItem?.assemblyID)){
        setConfigFileExists(true);
      }
    }
  }, [selectedDeleteItem])

  useEffect(()=>{
    console.log("useEffect called", Object.keys(configTableData.data).length)
    if(Object.keys(configTableData.data).length === 0){
      dispatch(getConfigurationTableData());
    }
  }, [])

  console.log("configFileExists", configFileExists)

  const RenderDeleteMsg = () => {
    return (
      <div className="deleteWanringMsg">
        {!configFileExists ? 
        <div>
          <p>
            <span>Are you sure </span> you want to delete{" "}
            {selectedDeleteItem?.assemblyName} <b></b>{" "}
          </p>
          <p>You can't undo this action.</p>
        </div>
        :
        <div>
          <p>
            <span>You can't delete this Assembly file as there is Config file associated with it.</span> 
          </p>
        </div>}
      </div>
    );
  };

  const RenderResponse = () => {
    return (
      <>
        {response?.status === 200 ? (
          <div ClassName="failedMsg">
            <div className="successMsg">
              <i className="now-ui-icons ui-1_check"></i>&nbsp; Success
            </div>
            <div className="successTxt">File Deleted Successfully</div>
          </div>
        ) : (
          <div>
            <div ClassName="failedMsg">
              <div className="failed">
                <i className="now-ui-icons ui-1_simple-remove"></i>&nbsp; Failed
              </div>
              <div className="failedTxt">
                {response?.responseDesc || "Error in assembly delete!"}
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <Modal
      title={<h3>Delete Assembly File</h3>}
      visible={isModalOpen}
      onCancel={() => {
        setIsModalOpen(false);
        setLoading(false);
        setResponse("");
      }}
      onOk={() => {
        if (response || configFileExists) {
          setIsModalOpen(false);
          setLoading(false);
          setResponse("");
        } else {
          handleOnDelete();
        }
      }}
      okText={response || configFileExists ? "OK" : "Delete"}
      destroyOnClose
      width={800}
      confirmLoading={loading}
      // size={"large"}
    >
      {response ? <RenderResponse /> : <RenderDeleteMsg />}
    </Modal>
  );
}

export default DeleteAssemblyModal;
